import React from 'react';
import { TouchableOpacity } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

type Props = {
  title: string;
  description: string;
  ctaLabel: string;
  onCta: () => void;
};

export const ChatPhotoRequestNudge: React.FC<Props> = ({
  title,
  description,
  ctaLabel,
  onCta,
}) => {
  return (
    <Box
      mx='m'
      mb='s'
      padding='m'
      backgroundColor='black'
      borderRadius='xs'
      flexDirection='row'
      alignItems='center'
      style={{
        shadowColor: 'black',
        shadowOpacity: 0.05,
        shadowOffset: { width: 0, height: 5 },
        shadowRadius: 25,
        elevation: 5,
        gap: theme.spacing.m,
      }}>
      <Box
        width={40}
        height={40}
        borderRadius='xxl'
        backgroundColor='greenDark'
        alignItems='center'
        justifyContent='center'
        flexShrink={0}>
        <Icon name='Camera' variant='m' color='greenBrand' />
      </Box>
      <Box flex={1} style={{ gap: theme.spacing.xxs }}>
        <Text variant='labelEmphasizedNudgeTitle'>{title}</Text>
        <Text variant='webBodyHintSubline' color='white'>
          {description}
        </Text>
      </Box>
      <TouchableOpacity onPress={onCta} style={{ flexShrink: 0 }}>
        <Box
          backgroundColor='greenSecondary'
          borderRadius='xs'
          paddingHorizontal='m'
          height={32}
          alignItems='center'
          justifyContent='center'>
          <Text variant='labelSmall' color='white'>
            {ctaLabel}
          </Text>
        </Box>
      </TouchableOpacity>
    </Box>
  );
};
